export const en = {
  addComment: 'Add a comment'
};

export type Translations = typeof en;
